<template>
  <v-dialog width="800px" v-model="show" @click:outside="$store.commit('close_edit_news_pic_dialog')">
    <v-card>
      <validation-observer v-slot="{ invalid }">
        <v-card-title>
          ویرایش تصویر خبر
        </v-card-title>
        <v-card-text>
          <validation-provider
              v-slot="{ errors }"
              rules="required"
          >
            <v-file-input v-model="edit_value.image" filled :error-messages="errors" outlined
                          label="تصویر" required>
            </v-file-input>
          </validation-provider>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="$store.commit('close_edit_news_pic_dialog')">
            لغو
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="invalid" @click="$store.dispatch('edit_news', {edit_picture:true , values: edit_value})">
            ویرایش
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>

</template>

<script>
import {mapState} from "vuex";
import {ValidationObserver} from "vee-validate";
import {ValidationProvider} from "vee-validate";
import static_config from "@/components/common/Statics";

export default {
  name: "EditNewsPicDialog",
  data: () => {
    return {
      value: null,
      months: static_config.months,
    }

  },
  computed: {
    ...mapState({
      show: state => state.Admin.settings.edit_news_pic_dialog.show,
      edit_value: state => state.Admin.settings.edit_news_pic_dialog.news,
    }),

  },
  components: {
    ValidationProvider,
    ValidationObserver,
  }
}
</script>

<style scoped>

</style>